import React from 'react'
import LayoutMain from "../../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../../Partials/LeftSidedImageCopyItem/collection";
import ProjectImageDatePageCollection from "../../../Partials/ProjectImageDetailPage/Collection";
import BannerWithButton from "../../../Partials/BannerWithButton/index";


const leftSidedImageCopyItemCollectionData = [
    {
        description : [
            'The front landscape design is considered and restrained so as not to compete with the traditional Victorian architecture of this Darling Point home. Large established trees complement the scale of the home and provide a beautiful dappled light in the warm summer months. The lush green planting is selected to flourish in the shaded conditions.',
            'The contemporary renovation of the rear of the house has lead a modern, fresh and bold selection of pots and plants for the internal courtyard. Pleached Bamboo provides privacy screening and a soft green backdrop to the private entertaining area. Contemporary white furniture and potted planting create layers of greenery that further soften and add interest when viewed from internal living areas.'
        ],
        descriptionContent : (
          <p>
          <span className="line">
          <b>Services Undertaken</b>
          <br />Landscape Architecture
          <br />Construction
          </span>
          
          <b>Design Features</b>
          <br />Contemporary
          <br />Family
          <br />Entertainer
          <br />Classic
          </p>
        ),
        image : '../images/projects/darling-5.jpg',
        title : 'Darling Point'
    }
]

const projectImageDetailPageCollectionData = [
    {
        dataId : 'a1',
        image : '../images/projects/darling-1.jpg'
    },
    {
        dataId : 'a8',
        image : '../images/projects/darling-2.jpg'
    },
    {
        dataId : 'a2',
        image : '../images/projects/darling-3.jpg'
    },
    {
        dataId : 'a4',
        image : '../images/projects/darling-4.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/darling-5.jpg'
    },
    {
        dataId : 'a5',
        image : '../images/projects/darling-6.jpg'
    },
]

const PageDarlingPoint = () => {
  return (
    <LayoutMain>
          <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className="pb-100">
        <div className="container-3">
          <div className="row">
            <ProjectImageDatePageCollection
              data={projectImageDetailPageCollectionData}
            />
          </div>
        </div>
      </section>
      <BannerWithButton />
        </LayoutMain>
  )
}

export default PageDarlingPoint